// 3. PURE HELPERS
export function buildVietQRUrl({ bank, account, accountName }) {
  const query = new URLSearchParams({ accountName: accountName.trim() });
  return `https://img.vietqr.io/image/${encodeURIComponent(bank)}-${encodeURIComponent(account)}-compact.png?${query.toString()}`;
}

// 4. QR IMAGE REQUEST
export async function getVietQRBase64(qrUrl) {
  const response = await fetch(qrUrl, { mode: "cors" });
  if (!response.ok) throw new Error("Không lấy được ảnh VietQR");
  const blob = await response.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
